const LIVE_DEVICE_LOAD_REQUEST = "load";
const LIVE_DEVICE_REFRESH_REQUEST = "refresh";

export const liveDeviceMqttMixin = {
  data() {
    return {
      mqttTopic: null,
      mqttMessageHandler: null,
      liveDeviceComponentActive: true,
      liveDeviceRequestIds: {
        [LIVE_DEVICE_LOAD_REQUEST]: 0,
        [LIVE_DEVICE_REFRESH_REQUEST]: 0,
      },
    };
  },
  beforeDestroy() {
    this.liveDeviceComponentActive = false;
    this.resetLiveDeviceLifecycle();
  },
  methods: {
    normalizeLiveDevicePlantId(plantId) {
      return plantId === null || plantId === undefined ? "" : String(plantId);
    },
    beginLiveDeviceRequest(scope, plantId = this.getSelectedPlantId) {
      const requestId = (this.liveDeviceRequestIds[scope] || 0) + 1;
      this.liveDeviceRequestIds[scope] = requestId;

      return {
        scope,
        requestId,
        plantId: this.normalizeLiveDevicePlantId(plantId),
      };
    },
    invalidateLiveDeviceRequest(scope) {
      this.liveDeviceRequestIds[scope] =
        (this.liveDeviceRequestIds[scope] || 0) + 1;
    },
    beginLiveDeviceLoad(plantId = this.getSelectedPlantId) {
      this.stopLiveDeviceRefresh();
      this.stopLiveDeviceMqtt();
      this.invalidateLiveDeviceRequest(LIVE_DEVICE_REFRESH_REQUEST);
      return this.beginLiveDeviceRequest(LIVE_DEVICE_LOAD_REQUEST, plantId);
    },
    beginLiveDeviceRefresh(plantId = this.getSelectedPlantId) {
      return this.beginLiveDeviceRequest(LIVE_DEVICE_REFRESH_REQUEST, plantId);
    },
    isLiveDevicePlantCurrent(plantId) {
      return this.liveDeviceComponentActive &&
        this.normalizeLiveDevicePlantId(plantId) ===
          this.normalizeLiveDevicePlantId(this.getSelectedPlantId);
    },
    isLiveDeviceRequestCurrent(request) {
      return Boolean(request) &&
        this.isLiveDevicePlantCurrent(request.plantId) &&
        request.requestId === this.liveDeviceRequestIds[request.scope];
    },
    isLiveDeviceLoadCurrent(request) {
      return this.isLiveDeviceRequestCurrent(request);
    },
    resetLiveDeviceLifecycle() {
      this.invalidateLiveDeviceRequest(LIVE_DEVICE_LOAD_REQUEST);
      this.invalidateLiveDeviceRequest(LIVE_DEVICE_REFRESH_REQUEST);
      this.stopLiveDeviceRefresh();
      this.stopLiveDeviceMqtt();
    },
    stopLiveDeviceRefresh() {
      if (!this.cacheInterval) return;
      clearInterval(this.cacheInterval);
      this.cacheInterval = null;
    },
    startLiveDeviceMqtt(
      device,
      updateHandler,
      plantId = this.getSelectedPlantId
    ) {
      if (
        !this.liveDeviceComponentActive ||
        !this.$mqtt ||
        !device ||
        !this.normalizeLiveDevicePlantId(plantId) ||
        typeof updateHandler !== "function"
      ) return;

      const normalizedPlantId = this.normalizeLiveDevicePlantId(plantId);
      const topicName = `live/${normalizedPlantId}/${device}`;
      if (this.mqttTopic === topicName && this.mqttMessageHandler) return;

      this.stopLiveDeviceMqtt();

      const messageHandler = (topic, message) => {
        if (
          !this.liveDeviceComponentActive ||
          this.mqttTopic !== topicName ||
          topic !== topicName
        ) return;

        try {
          const payload = JSON.parse(message.toString());
          const deviceList = Array.isArray(payload.deviceList)
            ? payload.deviceList
            : [payload];

          deviceList.forEach(updateHandler);
        } catch (error) {
          console.error(`MQTT Parsing error for ${device}`, error);
        }
      };

      this.mqttTopic = topicName;
      this.mqttMessageHandler = messageHandler;
      this.$mqtt.on("message", messageHandler);
      this.$mqtt.subscribe(topicName);
    },
    stopLiveDeviceMqtt() {
      const topicName = this.mqttTopic;
      const messageHandler = this.mqttMessageHandler;

      this.mqttTopic = null;
      this.mqttMessageHandler = null;

      this.removeLiveDeviceMqttListener("message", messageHandler);
      if (topicName && this.$mqtt) {
        this.$mqtt.unsubscribe(topicName);
      }
    },
    removeLiveDeviceMqttListener(eventName, handler) {
      if (!handler || !this.$mqtt) return;

      if (typeof this.$mqtt.off === "function") {
        this.$mqtt.off(eventName, handler);
      } else if (typeof this.$mqtt.removeListener === "function") {
        this.$mqtt.removeListener(eventName, handler);
      }
    },
  },
};
